var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-grid p-chat"},[_c('div',{staticClass:"p-col-12"},[_c('CustomBreadcrumb',{attrs:{"items":_vm.items_bread_crumb}}),_c('div',{staticClass:"manager-title"},[_vm._v(_vm._s(_vm.title))]),_c('List')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }